module.exports = __webpack_public_path__ + "static/img/Chad-Townsend.9aa31e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Chad-Townsend.jpg
// module id = SRQt
// module chunks = 0